<template>
  <div>
    <div>
      <search-bar></search-bar>
    </div>

    <!--{{priFound}}-->
    <!--
    {{priDt}}
    -->
    <v-container v-if="priFound && isFound">
      <school-info :info="priDt.info"></school-info>   
      <v-layout class="mt-3">
        
      </v-layout>
      <v-layout>
        <v-flex>
        <v-stepper class="mt-3" v-model="e4" vertical>

          <last-rec :datevalue="priDt.lastRev" 
            labelText="* ថ្ងៃ ខែ ឆ្នាំចុងក្រោយដែលទទួលបានសៀវភៅសិក្សាគោលពីក្រសួងអប់រំយុវជននិងកីឡា៖ "
          >
          </last-rec> 
          
          <div id="page1"></div>
          <v-stepper-step editable step="1">
            <big class="mainTitle">{{mTitle[0]}}</big>
          </v-stepper-step>
          <v-stepper-content step="1">          
            <pri-basic-info :tstudent="priDt.tStu" :tteacher="priDt.tTea" :extradata="priDt.edata"></pri-basic-info>
            <v-btn class="sttext" small color="primary" @click="$vuetify.goTo('#page4',{ offset: 100 });e4 = 2">ទៅកាន់ ២</v-btn>
          </v-stepper-content>

          <div id="page2"></div>
          <v-stepper-step editable step="2">
            <big class="mainTitle">{{mTitle[1]}}{{getAcc.curAcc}}</big>
          </v-stepper-step>
          <v-stepper-content step="2">
            <pri-table-group :fTitle="sTitle[0]" :fData="priDt.t1" :sTitle="sTitle[1]" :sData="priDt.t2"></pri-table-group>
            <v-btn class="sttext" small color="primary" @click="$vuetify.goTo('#page3');e4 = 3">ទៅកាន់ ៣.ក</v-btn>
          </v-stepper-content>

          <div id="page3"></div>
          <v-stepper-step editable step="3">
            <big class="mainTitle">{{mTitle[2]}}<br>{{mTitle[3]}}({{getAcc.lstAcc}})</big>
          </v-stepper-step>
          <v-stepper-content step="3">
            <pri-table-group :fTitle="sTitle[2]" :fData="priDt.t3" :sTitle="sTitle[3]" :sData="priDt.t4"></pri-table-group>
            <v-btn class="sttext" small color="primary" @click="$vuetify.goTo('#page4');e4 = 4">ទៅកាន់ ៣.ខ</v-btn>
          </v-stepper-content>

          <div id="page4"></div>
          <v-stepper-step editable step="4">
            <big class="mainTitle">{{mTitle[4]}}{{getAcc.curAcc}}</big>
          </v-stepper-step>
          <v-stepper-content step="4">
            <pri-table-group :fTitle="sTitle[4]" :fData="priDt.t5" :sTitle="sTitle[5]" :sData="priDt.t6"></pri-table-group>
            <v-btn class="sttext" small color="primary" @click="$vuetify.goTo('#page1');e4 = 1">ទៅកាន់ ១</v-btn>
          </v-stepper-content>
          
        </v-stepper>
        </v-flex>
      </v-layout>
    </v-container>
    <div v-if="isFound && priFound">
      <navigation-bar></navigation-bar>
    </div>
  </div>
</template>

<script>
import apCon from '@/utils/textbookConfig.js'
const SearchBar = () => import('@/components/common/SearchBar.vue')
const schoolInfo = () => import('@/components/common/SchoolInfo.vue')
const lastRe = () => import('@/components/common/dateinput.vue')
const priBasicInfo = () => import('@/components/textbook/primaryBasicInfo.vue')
const priTableGroup = () => import('@/components/textbook/primaryTableGroup.vue')
const NavigationBar = () => import('@/components/common/NavigationBar.vue')

export default {
  components: {
    'searchBar': SearchBar,
    'school-info': schoolInfo,
    'last-rec': lastRe,
    'pri-basic-info': priBasicInfo,
    'pri-table-group': priTableGroup,
    'navigationBar': NavigationBar
  },
  data () {
    return {
      isFound: false,
      e4: 1,
      sTitle: apCon.tbSubTitle,
      mTitle: apCon.tbMainTitle
    }
  },
  methods: {
  },
  computed: {
    getAcc: function () {
      return {
        curAcc: this.$store.state.uiControl.cur_acc_text,
        lstAcc: this.$store.state.uiControl.lst_acc_text
      }
    },
    priFound: function () {
      if (this.$store.state.textbook.school_dt_pri.res === '1') {
        this.isFound = true
        this.e4 = 1
        // set the schoolState to the UI store for enable/disable SAVE Button
        this.$store.dispatch('uiControl/setSchoolState', this.$store.state.textbook.school_dt_pri.state_code.sta_code)
        return true
      }
    },
    priDt: function () {
      return {
        info: this.$store.state.textbook.school_dt_pri,
        edata: this.$store.state.textbook.school_dt_pri.extra,
        tStu: this.$store.state.textbook.school_dt_pri.stu_by_grade,
        tTea: this.$store.state.textbook.school_dt_pri.tec_by_grade,
        lastRev: this.$store.state.textbook.school_dt_pri.date_rec,
        t1: this.$store.state.textbook.school_dt_pri.textbook_t1,
        t2: this.$store.state.textbook.school_dt_pri.textbook_t2,
        t3: this.$store.state.textbook.school_dt_pri.textbook_t3,
        t4: this.$store.state.textbook.school_dt_pri.textbook_t4,
        t5: this.$store.state.textbook.school_dt_pri.textbook_t5,
        t6: this.$store.state.textbook.school_dt_pri.textbook_t6
      }
    }
  },
  created () {
    this.$store.dispatch('textbook/loadDefaultTextbookPri')
    this.$store.dispatch('uiControl/setEnableSave')
  }
}
</script>

<style scoped>
  .mainTitle {
    font-weight: bold;
    font-family: "khmer OS";
    font-size: 14px;
  }
  .sttext {
  font-family: "khmer OS";
  font-size: 12px;
  }
</style>